import type { TenantAdmin, TenantAdminBase } from "../../../types/admin";
import { createAdminBaseService } from "./adminBaseService";

const base = createAdminBaseService<TenantAdmin, TenantAdminBase>({
  tableName: "tenants",
  searchColumns: ["name", "slug"],
});

export class AdminTenantService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
